import React, { Component } from 'react'

export default class Timeline extends Component {
  render() {
    return (
      <div>
        <section className="colorlib-experience" data-section="timeline">
          <div className="colorlib-narrow-content">
            <div className="row">
              <div className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box" data-animate-effect="fadeInLeft">
                <span className="heading-meta">highlights</span>
                <h2 className="colorlib-heading animate-box">Timeline</h2>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="timeline-centered">
                  <article className="timeline-entry animate-box" data-animate-effect="fadeInTop">
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-3">
                        <i className="icon-pen2" />
                      </div>
                      <div className="timeline-label">
                        <h2>Pak'nSave <span>2019-2020</span></h2>
                        <p> I worked briefly at Pak'nSave where I was put into a professional role with my own responsibilities and expectations. 
							Here I worked with other team members and also independently to meet customer needs and requests in an often busy and chaotic environment.
							Being able to have a positive and respectful attitude when interacting and communicating with external and internal customers was very beneficial.</p>
                      </div>
                    </div>
                  </article>
                  <article className="timeline-entry animate-box" data-animate-effect="fadeInLeft">
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-4">
                        <i className="icon-pen2" />
                      </div>
                      <div className="timeline-label">
                        <h2>Auckland University of Technology <span>2014-2017</span></h2>
                        <p> I spent 3 years at AUT earning my Bachelor of Computer Sciences where I majored in Computer Science and Software Development. Here I learnt 
							about the various aspects of coding and computer science including program design, databases, data structures, algorithms, IT project management, 
							web development and much more!</p>
                      </div>
                    </div>
                  </article>
                  <article className="timeline-entry animate-box" data-animate-effect="fadeInLeft">
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-5">
                        <i className="icon-pen2" />
                      </div>
                      <div className="timeline-label">
                        <h2>Primary and Higher Education <span>2009-2013</span></h2>
                        <p> I earnt my National Certificate of Educational Achievement (NCEA) Level 3 at Alfriston College. This is where I learnt many basic subjects such as Math, English
						    and Physics. </p> 
                      </div>
                    </div>
                  </article>
                  <article className="timeline-entry begin animate-box" data-animate-effect="fadeInBottom">
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-none">
                      </div>
                    </div>
                  </article>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    )
  }
}
